import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { _InputCheckboxStyled, _InputCheckboxLabel } from "./style";
import ErrorContainer from "../input/ErrorContainer";
var InputCheckbox = function InputCheckbox(_ref) {
  var checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    name = _ref.name,
    onChange = _ref.onChange,
    labelText = _ref.labelText,
    required = _ref.required,
    error = _ref.error,
    input = _ref.input,
    display = _ref.display,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputCheckboxStyled, {
    display: display,
    required: required
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    defaultChecked: defaultChecked,
    checked: checked === undefined ? input && input.value : checked,
    name: name || input && input.name,
    onChange: onChange || input && input.onChange,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(_InputCheckboxLabel, {
    required: required
  }, labelText)), /*#__PURE__*/React.createElement(ErrorContainer, {
    error: error
  }));
};
InputCheckbox.propTypes = {
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  name: PropTypes.string,
  labelText: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func
};
export default InputCheckbox;